/* eslint-disable */
export default {
  keyword: {
    dropdown: {
      tour: [{
        id: 147930
      }, {
        id: 142297
      }]
    },
    link: {
      addKeyword: {
        id: 147930
      },
      changeBid: {
        id: 142297
      }
    }
  },
  settings: {
    dropdown: {
      tour: [{
        id: 141547
      }]
    },
    link: {
      id: 141547
    }
  },
  audience: {
    dropdown: {
      tour: [{
        id: 144778
      }, {
        id: 125409
      }]
    },
    link: [{
      id: 144778
    }, {
      id: 125409
    }, {
      id: 144779
    }, {
      id: 144780
    }, {
      id: 144781
    }]
  }
};

